import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { VerifyAdvocateFromTls } from './verify-advocate-from-tls.model';
import * as VerifyAdvocateFromTlsActions from './verify-advocate-from-tls.actions';

export const verifyAdvocateFromTlsFeatureKey = 'verifyAdvocateFromTls';

export interface State extends EntityState<VerifyAdvocateFromTls> {
  // additional entities state properties
}

export const adapter: EntityAdapter<VerifyAdvocateFromTls> = createEntityAdapter<VerifyAdvocateFromTls>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});


export const reducer = createReducer(
  initialState,

  // Add a verified advocate from TLS
  on(VerifyAdvocateFromTlsActions.addVerifiedAdvocate, (state, action) =>
    adapter.addOne(action.VerifyAdvocateFromTls, state)
  ),

  // Upsert a single work experience
  on(VerifyAdvocateFromTlsActions.upsertVerifiedAdvocate, (state, action) =>
    adapter.upsertOne(action.VerifyAdvocateFromTls, state)
  ),

  // Add multiple work experiences
  on(VerifyAdvocateFromTlsActions.addVerifiedAdvocates, (state, action) =>
    adapter.addMany(action.VerifiedAdvocate, state)
  ),

  // Upsert multiple work experiences
  on(VerifyAdvocateFromTlsActions.upsertVerifiedAdvocates, (state, action) =>
    adapter.upsertMany(action.VerifiedAdvocate, state)
  ),

  // Update a single work experience
  on(VerifyAdvocateFromTlsActions.updateVerifiedAdvocate, (state, action) =>
    adapter.updateOne(action.VerifyAdvocateFromTls, state)
  ),

  // Update multiple work experiences
  on(VerifyAdvocateFromTlsActions.updateVerifiedAdvocates, (state, action) =>
    adapter.updateMany(action.VerifiedAdvocate, state)
  ),

  // Remove a single work experience
  on(VerifyAdvocateFromTlsActions.deleteVerifiedAdvocate, (state, action) =>
    adapter.removeOne(action.id, state)
  ),

  // Remove multiple work experiences
  on(VerifyAdvocateFromTlsActions.deleteVerifiedAdvocates, (state, action) =>
    adapter.removeMany(action.ids, state)
  ),

  // Load all work experiences (replace all)
  on(VerifyAdvocateFromTlsActions.loadVerifiedAdvocate, (state, action) =>
    adapter.setAll(action.VerifiedAdvocate, state)
  ),

  // Clear all work experiences
  on(VerifyAdvocateFromTlsActions.clearVerifiedAdvocate, state =>
    adapter.removeAll(state)
  ),
);


export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
